module.exports = __webpack_public_path__ + "static/media/20230602_CGV_Allo_18.57dac415.docx";